import { render, staticRenderFns } from "./MoratoriaSojaLista.vue?vue&type=template&id=ef4d1974&lang=pug"
import script from "./MoratoriaSojaLista.vue?vue&type=script&lang=js"
export * from "./MoratoriaSojaLista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports